import type { DetailsTab } from './TaskDetails.types'

/**
 * **Der zuletzt benutzte Reiter der Aufgaben-Details** (#183; Sven, 29.09.2026, nach dem
 * Funktionstest): Neu geöffnet zeigen die Details, was man zuletzt offen hatte.
 *
 * **Gerätelokal und für alle Seiten** — wie die Seite der Werkzeug-Pille (`canvasToolbarSide.ts`):
 * eine Gewohnheit der Ansicht, kein Inhalt, also kein Sync.
 */
export const LAST_DETAILS_TAB_KEY = 'happytask:taskDetails:lastTab'

export function readLastDetailsTab(): DetailsTab {
  try {
    return localStorage.getItem(LAST_DETAILS_TAB_KEY) === 'comments' ? 'comments' : 'details'
  } catch {
    // Im privaten Fenster wirft schon das Lesen.
    return 'details'
  }
}

export function rememberDetailsTab(tab: DetailsTab): void {
  try {
    localStorage.setItem(LAST_DETAILS_TAB_KEY, tab)
  } catch {
    // Kein Speicher (privates Fenster, volles Kontingent) — dann gilt er nur, solange die Details offen sind.
  }
}
